import React from 'react'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import { useSelector } from 'react-redux'
import { RootState } from 'src/store'
const PageLoader = () => {
  const { isPageLoading } = useSelector((state: RootState) => state.common)
  const { loading } = useSelector((state: RootState) => state.auth)

  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 10000000 }}
      open={isPageLoading || loading}
    >
      <CircularProgress color='inherit' />
    </Backdrop>
  )
}

export default PageLoader
